import { PayloadAction, ReducerCreators } from '@reduxjs/toolkit';

import { CategoriesState } from './types';
import { RootState } from '@/store/main';
import { FetchCategories } from '@/connection/categories/categories';
import { FetchAllProjectCategoriesForChannel } from '@/connection/categories/all-project-categories-for-channel';

export const reducers = (create: ReducerCreators<CategoriesState>) => ({
  fetchCategories: create.asyncThunk(
    async (
      { channel, returnStoreStateIfExists = true }: { channel: number; returnStoreStateIfExists?: boolean },
      { getState }
    ) => {
      if (returnStoreStateIfExists) {
        // return from state if exists
        const state = getState() as RootState;
        const categories = state?.categories?.categories as [] | null;
        if (categories) {
          return categories;
        }
      }
      return FetchCategories(channel);
    },
    {
      fulfilled: (state, action) => {
        state.categories = action.payload;
        state.loadingCategories = false;
      },
      pending: (state) => {
        state.loadingCategories = true;
      },
      rejected: (state, action) => {
        state.loadingCategories = false;
        console.error(action.error);
        // TODO
        // add an error to state and show alert in the UI component
      },
    }
  ),
  fetchAllProjectCategoriesForChannel: create.asyncThunk(
    async (
      {
        channel,
        returnStoreStateIfExists = true,
        templatesOnly = true,
      }: {
        channel: number;
        returnStoreStateIfExists?: boolean;
        templatesOnly?: boolean;
      },
      { getState }
    ) => {
      if (returnStoreStateIfExists) {
        // return from state if exists
        const state = getState() as RootState;
        const categories = state?.categories?.allProjectCategoriesForChannel as string[] | null;
        if (categories) {
          return { categories };
        }
      }
      return FetchAllProjectCategoriesForChannel(channel, { includeGlobalProjectCategories: true, templatesOnly });
    },
    {
      fulfilled: (state, action) => {
        state.allProjectCategoriesForChannel = action.payload.categories || [];
        state.loadingAllProjectCategoriesForChannel = false;
      },
      pending: (state) => {
        state.loadingAllProjectCategoriesForChannel = true;
      },
      rejected: (state, action) => {
        state.loadingAllProjectCategoriesForChannel = false;
        console.error(action.error);
      },
    }
  ),
  setAllProjectCategoriesInStoreOnly: create.reducer((state, action: PayloadAction<string[] | null>) => {
    state.allProjectCategoriesForChannel = action.payload || [];
  }),
});
